import React from 'react';
import { useQuery } from '@apollo/client';
import { Navigate } from 'react-router-dom';
import { ME } from '../../graphql/queries';

interface RouteForAdminProps {
  children: React.ReactNode;
}

const RouteForAdmin: React.FC<RouteForAdminProps> = ({ children }) => {
  const { loading, error, data } = useQuery(ME);
  if (loading) return <p>Проверка прав...</p>;
  if (error || !data?.me) return <Navigate to="/no-access" />;

  const user = data.me;

  const hasAccess =
    ['admin', 'superadmin'].includes(user.role);

  if (!hasAccess) return <Navigate to="/no-access" />;

  return <>{children}</>;
};

export default RouteForAdmin;